<template>
<article class="info-section">
  <div class="info-section-header">
    <InfoSectionHeading>Generations</InfoSectionHeading>
    <p class="info-section-description">{{description}}</p>
    <div class="button-holder" v-if="authenticated">
      <router-link
        :to="`/generation/create`"
        class="elr-button elr-button-primary"
        v-if="user && user.role_id <= 2"
      >Create New Generation</router-link>
    </div>
  </div>
  <div class="filter">
    <p>Total: {{total}} {{total === 1 ? 'generation' : 'generations'}}</p>
    <ViewToggle :displayStyle="displayStyle" @toggled="CHANGE_DISPLAY_STYLE" />
    <div class="button-holder sort-list">
      <SortToggle
        field="name"
        :activeField="sort.field"
        :direction="sort.direction"
        buttonLabel="Generation Name"
        @sorted="SORT"
      />
      <SortToggle
        field="num_groupings"
        :activeField="sort.field"
        :direction="sort.direction"
        buttonLabel="Number Groupings"
        @sorted="SORT"
      />
      <SortToggle
        field="num_ponies"
        :activeField="sort.field"
        :direction="sort.direction"
        buttonLabel="Number Ponies"
        @sorted="SORT"
      />
    </div>
  </div>
  <GenerationItemList
    v-if="status && displayStyle === 'list'"
    :items="generations"
    :total="total"
    :user="user"
    @onRemove="REMOVE"
  />
  <ListItemGrid v-if="status && displayStyle === 'grid'" :status="status">
    <GenerationCard
      :key="item.id"
      v-for="item in generations"
      :user="user"
      :item="item"
      @onRemove="REMOVE(item.slug)"
    />
  </ListItemGrid>
</article>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import { num } from '../../data/config';
import { infiniteScroll } from '../../utils/helpers';

import GenerationCard from '../../components/GenerationCard/GenerationCard';
import GenerationItemList from '../../components/GenerationItemList/GenerationItemList';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';
import ListItemGrid from '../../components/ListItemGrid/ListItemGrid';
import SortToggle from '../../components/SortToggle/SortToggle';
import ViewToggle from '../../components/ViewToggle/ViewToggle';

export default {
  name: 'GenerationList',
  data() {
    return {
      errors: [],
    };
  },
  components: {
    GenerationCard,
    SortToggle,
    ViewToggle,
    InfoSectionHeading,
    ListItemGrid,
    GenerationItemList,
  },
  mounted() {
    this.FETCH_ALL({ num });
    infiniteScroll(() => {
      if (this.nextUrl && this.status !== 'loading') {
        this.$emit('onFetchMore');
      }
    });
  },
  computed: {
    ...mapGetters('generation', { generations: 'getAll' }),
    ...mapState({
      user: state => state.currentUser.currentUser,
      authenticated: state => state.currentUser.authenticated,
      heading: state => state.generation.heading,
      description: state => state.generation.description,
      status: state => state.generation.status,
      nextUrl: state => state.generation.nextUrl,
      displayStyle: state => state.generation.displayStyle,
      sort: state => state.generation.sort,
      total: state => state.generation.total,
    }),
  },
  methods: {
    ...mapActions('generation', [
      'FETCH_MORE',
      'FETCH_ALL',
      'REMOVE',
      'SORT',
      'CHANGE_DISPLAY_STYLE'
    ]),
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.filter {
  max-width: $max-width;
  margin-left: auto;
  margin-right: auto;
}

.button-holder {
  text-align: left;
}

.button-holder {
  text-align: left;
  padding-top: 0;
  
  .sort-button {
    margin-right: 10px;
    width: auto;
  }
}
</style>
